export const TableFormDataRowProp = Object.freeze({
    Cells: 'cells',
    Color: 'color',
    Mode: 'mode',
    UniqueRowId: 'uniqueRowId',
    RowNumber: 'rowNumber',
    HasSpinner: 'hasSpinner',
    ShowSpinner: 'showSpinner'
});